export default __webpack_public_path__ + "static/media/css.b3c0acbf.svg";